/**
 * Removes navigation items whose rollout flag has not been enabled yet.
 * An item opts in by declaring `rolloutFlag` with a key from the `FeatureFlags` registry —
 * that declaration is the only thing needed to gate it. Items without it are always kept.
 *
 * This is rollout gating, not entitlement: a `flag` property on a navigation object
 * (see `views/loyalty/vouchers/navigation.js`) is a `featureConfig` path and a different
 * mechanism altogether. Both can apply to the same item.
 * @param {Object[]} navArr - array of navigation trees
 * @param {Record<string, boolean>} rolloutFlags - resolved flags, as returned by
 *   `usePosthogFeatureFlags`, which evaluates each one through Posthog. A missing key counts
 *   as disabled.
 * @returns {Object[]}
 */
export function filterNavByRolloutFlags(navArr, rolloutFlags = {}) {
  return navArr.reduce((acc, item) => {
    if (item.rolloutFlag && !rolloutFlags[item.rolloutFlag]) {
      return acc
    }

    const children = item.children
      ? filterNavByRolloutFlags(item.children, rolloutFlags)
      : undefined

    return acc.concat({ ...item, children })
  }, [])
}
